<div *transloco="let t" class="bg-light-02 rounded-b-l rounded-t-l p-xs flex-col flex-grow">
	<beyond-online-headline
		size="s"
		[headline]="t('orderSummary.subComponents.rxVRXDisplay.headlines.title')"
	></beyond-online-headline>
	@if (showVrxData) {
		<beyond-online-tab-group>
			<beyond-online-tab-navigation
				[label]="t('generalComponents.prescription.texts.rx')"
				[active]="true"
			>
				<ng-container *ngTemplateOutlet="rxValues"></ng-container>
			</beyond-online-tab-navigation>
			<beyond-online-tab-navigation [label]="t('generalComponents.prescription.texts.vrx')">
				<div
					class="mt-2xs content-center text-center"
					*ngIf="$vrxData() as vrx; appLoadingAnimation"
				>
					<div class="flex items-center ml-xl">
						<div
							class="flex flex-col w-1/4 text-label text-body justify-center h-l border-b border-inactive"
						>
							{{ t('generalComponents.prescription.texts.sphere') }}
						</div>
						<div
							class="flex flex-col w-1/4 text-label text-body justify-center h-l border-b border-inactive"
						>
							{{ t('generalComponents.prescription.texts.cylinder') }}
						</div>
						<div
							class="flex flex-col w-1/4 text-label text-body justify-center h-l border-b border-inactive"
						>
							{{ t('generalComponents.prescription.texts.axis') }}
						</div>
						<div
							class="flex flex-col w-1/4 text-label text-body justify-center h-l border-b border-inactive"
						>
							{{ t('generalComponents.prescription.texts.addition') }}
						</div>
					</div>
					<div class="flex">
						<div
							class="flex flex-col w-xl text-label text-body justify-center first-letter text-left"
						>
							{{ t('generalComponents.prescription.texts.rightEyeDesktop') }}
						</div>
						<div
							class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
						>
							{{ vrx?.right?.sphere | positiveDecimal }}
						</div>
						<div
							class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
						>
							{{ vrx?.right?.cylinder | positiveDecimal }}
						</div>
						<div
							class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
						>
							{{ vrx?.right?.axis | degree }}
						</div>
						<div
							class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
						>
							{{ vrx?.right?.addition | positiveDecimal }}
						</div>
					</div>
					<div class="flex">
						<div class="flex flex-col w-xl text-label text-body justify-center text-left">
							{{ t('generalComponents.prescription.texts.leftEyeDesktop') }}
						</div>
						<div
							class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
						>
							{{ vrx?.left?.sphere | positiveDecimal }}
						</div>
						<div
							class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
						>
							{{ vrx?.left?.cylinder | positiveDecimal }}
						</div>
						<div
							class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
						>
							{{ vrx?.left?.axis | degree }}
						</div>
						<div
							class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
						>
							{{ vrx?.left?.addition | positiveDecimal }}
						</div>
					</div>
				</div>
			</beyond-online-tab-navigation>
		</beyond-online-tab-group>
	} @else {
		<ng-container *ngTemplateOutlet="rxValues"></ng-container>
	}

	<ng-template #rxValues>
		<div class="mt-2xs content-center text-center">
			<div class="flex items-center ml-xl">
				<div
					class="flex flex-col w-1/4 text-label text-body justify-center h-l border-b border-inactive"
				>
					{{ t('generalComponents.prescription.texts.sphere') }}
				</div>
				<div
					class="flex flex-col w-1/4 text-label text-body justify-center h-l border-b border-inactive"
				>
					{{ t('generalComponents.prescription.texts.cylinder') }}
				</div>
				<div
					class="flex flex-col w-1/4 text-label text-body justify-center h-l border-b border-inactive"
				>
					{{ t('generalComponents.prescription.texts.axis') }}
				</div>
				<div
					class="flex flex-col w-1/4 text-label text-body justify-center h-l border-b border-inactive"
				>
					{{ t('generalComponents.prescription.texts.addition') }}
				</div>
			</div>
			<div class="flex">
				<div class="flex flex-col w-xl text-label text-body justify-center first-letter text-left">
					{{ t('generalComponents.prescription.texts.rightEyeDesktop') }}
				</div>
				<div
					class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
				>
					{{ rx?.right?.sphere | positiveDecimal }}
				</div>
				<div
					class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
				>
					{{ rx?.right?.cylinder | positiveDecimal }}
				</div>
				<div
					class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
				>
					{{ rx?.right?.axis | degree }}
				</div>
				<div
					class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
				>
					{{ rx?.right?.addition | positiveDecimal }}
				</div>
			</div>
			<div class="flex">
				<div class="flex flex-col w-xl text-label text-body justify-center text-left">
					{{ t('generalComponents.prescription.texts.leftEyeDesktop') }}
				</div>
				<div
					class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
				>
					{{ rx?.left?.sphere | positiveDecimal }}
				</div>
				<div
					class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
				>
					{{ rx?.left?.cylinder | positiveDecimal }}
				</div>
				<div
					class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
				>
					{{ rx?.left?.axis | degree }}
				</div>
				<div
					class="flex justify-center flex-col w-1/4 text-input text-headline h-l border-b border-inactive"
				>
					{{ rx?.left?.addition | positiveDecimal }}
				</div>
			</div>
		</div>
	</ng-template>
</div>
